import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MappingsContent from './mappings-content';
import MappingsTopHead from './mappings-top-head';
import { ReceivingShipmentService } from '../../service/api/receiving-shipment-service';
import { useLocation } from 'react-router-dom';
import { actions as mainActions } from 'Core/redux/main/slice';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { fetchReceivingShipmentsWithFilters } from './store/slice';
import {
  selectReceivingShipmentData,
  selectReceivingShipmentLoading,
} from './store/selectors';
import { fetchVendorsWithFilters } from '../vendormasters/store/slice';

const { setToogleHeader } = mainActions;

const MappingsView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const mappingsContentRef = useRef(null);
  const [tileView, setTileView] = useState(true);
  const headerVisible = useSelector(isHeaderVisible);
  const shipments = useSelector(selectReceivingShipmentData);
  const shipmentsLoading = useSelector(selectReceivingShipmentLoading);
  const [showMappingsUI, setShowMappingsUI] = useState(true);
  const [createdShipment, setCreatedShipment] = useState(null);
  const [createdShipmentId, setCreatedShipmentId] = useState(null);
  const [showReport, setShowReport] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const shipmentId = params.get('shipmentId');
    if (shipmentId) {
      setShowMappingsUI(false);
      setCreatedShipmentId(Number(shipmentId));
      ReceivingShipmentService.getShipmentById(shipmentId).then(response => {
        if (response && response.status === 200 && response.response) {
          setCreatedShipment(response.response);
        }
      });
    }
  }, [location.search]);

  useEffect(() => {
    dispatch(fetchReceivingShipmentsWithFilters());
    dispatch(fetchVendorsWithFilters({}));
  }, [dispatch]);

  const handleViewShipment = shipment => {
    // Implement view/edit logic or modal here
  };

  const handleAddNewShipment = () => {
    setCreatedShipment(null);
    setCreatedShipmentId(null);
    setShowMappingsUI(false);

    if (mappingsContentRef.current && mappingsContentRef.current.handleAddNewShipment) {
      mappingsContentRef.current.handleAddNewShipment();
    }
  };

  const refreshShipments = async () => {
    dispatch(fetchReceivingShipmentsWithFilters());
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Receiving Shipment</h4>
            </div>
          </div>
          {!showReport && (
            <MappingsTopHead
              tileView={tileView}
              onToggleView={setTileView}
              onCollapse={() => dispatch(setToogleHeader(!headerVisible))}
              collapsed={!headerVisible}
              onAddNewShipment={handleAddNewShipment}
              onViewReport={() => setShowReport(true)}
            />
          )}
        </div>
        <MappingsContent
          ref={mappingsContentRef}
          tileView={tileView}
          shipments={shipments}
          shipmentsLoading={shipmentsLoading}
          onViewShipment={handleViewShipment}
          showMappingsUI={showMappingsUI}
          setShowMappingsUI={setShowMappingsUI}
          onToggleView={setTileView}
          collapsed={!headerVisible}
          onCollapse={() => dispatch(setToogleHeader(!headerVisible))}
          onRefreshShipments={refreshShipments}
          createdShipment={createdShipment}
          createdShipmentId={createdShipmentId}
          showReport={showReport}
          setShowReport={setShowReport}
        />
      </div>
    </div>
  );
};

export default MappingsView;
